<template>
  <div v-if="visible" class="gl-cookie-banner-modal">
    <div class="gl-cookie-banner-modal__overlay"></div>
    <div class="gl-cookie-banner-modal__dialog" role="dialog" aria-modal="true" aria-label="Cookie settings">
      <h2 class="gl-cookie-banner__title">настройки файлов cookie</h2>
      <div class="gl-cookie-banner__text">
        <p class="gl-cookie-banner__text-paragraph">
          Мы используем файлы cookie и аналогичные технологии для обеспечения корректной работы Портала GS, повышения производительности платформы, анализа статистики использования и улучшения пользовательского опыта.
        </p>
        <p class="gl-cookie-banner__text-paragraph">
          Нажимая «<strong>Принять</strong>», вы даёте согласие на использование файлов cookie и аналогичных технологий в соответствии с нашей
          <a :href="privacyPolicyUrl" target="_blank" rel="noopener noreferrer">Политикой конфиденциальности.</a>
          Вы можете в любое время управлять своими предпочтениями через настройки браузера или устройства.
        </p>
      </div>
      <div class="gl-cookie-banner__actions">
        <button type="button" class="gl-cookie-banner__btn-reject" @click="reject">Отклонить</button>
        <button type="button" class="gl-cookie-banner__btn-accept" @click="accept">Принять</button>
      </div>
    </div>
  </div>
</template>
<script lang="ts" src="./cookie-consent-banner.ts"></script>
<style lang="scss" src="./cookie-consent-banner.scss"></style>
